import React from 'react';
import { PayoutFormRHF } from './PayoutFormRHF';
import type { Payout } from '../../types/payout';

interface PayoutFormOffCanvasProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (payout: Omit<Payout, 'id' | 'createdAt'>) => void;
  isLoading?: boolean;
  editingPayout?: Payout | null;
  onCancelEdit?: () => void;
}

export const PayoutFormOffCanvas: React.FC<PayoutFormOffCanvasProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  editingPayout,
  onCancelEdit,
}) => {
  const title = editingPayout ? 'Modifier la transaction' : 'Nouvelle transaction';
  const subtitle = editingPayout
    ? 'Modifiez les informations de cette transaction'
    : 'Enregistrez une nouvelle transaction';

  const handleSubmit = (payout: Omit<Payout, 'id' | 'createdAt'>) => {
    onSubmit(payout);
    onClose();
  };

  const handleCancel = () => {
    if (onCancelEdit) onCancelEdit();
    onClose();
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/30 z-40 transition-opacity"
          onClick={handleCancel}
        />
      )}

      <div
        className={`fixed top-0 right-0 h-full w-full min-[1534px]:w-[1150px] bg-white dark:bg-gray-800 shadow-2xl z-50 transition-transform duration-300 ease-in-out overflow-y-auto ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-6 border-b border-indigo-800 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-white">{title}</h2>
            <p className="text-blue-100 text-sm mt-1">{subtitle}</p>
          </div>
          <button
            onClick={handleCancel}
            className="p-2 hover:bg-blue-500 rounded-lg transition-colors"
            type="button"
          >
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="p-6">
          <PayoutFormRHF
            onSubmit={handleSubmit}
            isLoading={isLoading}
            editingPayout={editingPayout}
            onCancelEdit={handleCancel}
            alwaysExpanded
          />
        </div>
      </div>
    </>
  );
};
